var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Trash_Empty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00016 5.5V15.3333C5.00016 16.2668 5.00016 16.7331 5.18182 17.0897C5.34161 17.4033 5.59639 17.6587 5.90999 17.8185C6.26616 18 6.73266 18 7.66425 18H12.3361C13.2677 18 13.7335 18 14.0897 17.8185C14.4033 17.6587 14.6589 17.4033 14.8187 17.0897C15.0002 16.7335 15.0002 16.2675 15.0002 15.3359V5.5M5.00016 5.5H6.66683M5.00016 5.5H3.3335M6.66683 5.5H13.3335M6.66683 5.5C6.66683 4.72343 6.66683 4.33534 6.7937 4.02905C6.96285 3.62067 7.2871 3.29602 7.69548 3.12687C8.00176 3 8.39026 3 9.16683 3H10.8335C11.6101 3 11.9983 3 12.3046 3.12687C12.713 3.29602 13.0374 3.62067 13.2065 4.02905C13.3334 4.33534 13.3335 4.72343 13.3335 5.5M13.3335 5.5H15.0002M15.0002 5.5H16.6668",
    stroke: "#B4B4C4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTrash);
export default __webpack_public_path__ + "static/media/empty_trash.da8a80eed7879cefdb420905c372202c.svg";
export { ForwardRef as ReactComponent };